<form>
   <label for="cartNumber">{{ 'asm.bindCart.cartNumber' | cxTranslate }} </label>
   <div
      role="search"
      [attr.aria-label]="'asm.bindCart.assignCartId' | cxTranslate"
      [ngClass]="'cx-asm-assignCart-input-show-no-button'"
      [class.active]="valid$ | async"
      (click)="cartIdElement.focus()"
   >
      <input
         autocomplete="off"
         #cartIdElement
         formcontrolname="cartNumber"
         [formControl]="cartId"
         (keydown.enter)="bindCartToCustomer()"
         [attr.aria-label]="'asm.bindCart.enterCartId' | cxTranslate"
      />
   </div>
   @if (displayBindCartBtn$ | async) {
      <button
         #bindToCart
         class="cx-asm-bindCartToCustomer"
         [disabled]="!(valid$ | async)"
         type="submit"
         [class.cx-asm-active]="valid$ | async"
         [class.cx-bind-loading]="loading$ | async"
         (click)="bindCartToCustomer()"
      >
    <span [attr.aria-hidden]="loading$ | async">
      {{ 'asm.bindCart.bindCartToCustomer' | cxTranslate }}
    </span>
         <cx-dot-spinner
            [attr.aria-hidden]="!(loading$ | async)"
            [attr.aria-label]="'common.loading' | cxTranslate"
         />
      </button>
   }

   @if (displaySaveCartBtn$ | async) {
      <button
         id="asm-save-inactive-cart-btn"
         #saveInactiveCart
         class="cx-asm-bindCartToCustomer cx-asm-active"
         type="submit"
         [class.cx-bind-loading]="loading$ | async"
         (click)="onSaveInactiveCart()"
      >
    <span [attr.aria-hidden]="loading$ | async">
      {{ 'asm.saveCart.saveCartBtn' | cxTranslate }}
    </span>
         <cx-dot-spinner
            [attr.aria-hidden]="!(loading$ | async)"
            [attr.aria-label]="'common.loading' | cxTranslate"
         />
      </button>
   }

   @if (usersSalesNote()) {
      <button
         class="users-sales-note-btn"
         (click)="onUsersSalesNote()"
      >
         <span>
         {{ 'asm.usersSalesNote' | cxTranslate }}
       </span>
      </button>
   }
</form>
